module.exports = __webpack_public_path__ + "img/南板蓝根.bf24fd7b.jpg";